const CONVERT_THRESHOLD_BYTES = 1_500_000
const JPEG_QUALITY = 0.92

const replaceExtension = (name: string): string => {
  const stem = name.replace(/\.[^/.]+$/, '') || 'image'
  return `${stem}.jpg`
}

export async function prepareUploadFile(file: File): Promise<File> {
  if (file.size <= CONVERT_THRESHOLD_BYTES || file.type !== 'image/png') return file
  try {
    const bitmap = await createImageBitmap(file)
    const canvas = document.createElement('canvas')
    canvas.width = bitmap.width
    canvas.height = bitmap.height
    const context = canvas.getContext('2d', { willReadFrequently: true })
    if (!context) return file
    context.drawImage(bitmap, 0, 0)
    bitmap.close()
    const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data
    for (let index = 3; index < pixels.length; index += 4) {
      if (pixels[index] < 255) return file
    }
    const jpeg = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY),
    )
    if (!jpeg || jpeg.size >= file.size) return file
    return new File([jpeg], replaceExtension(file.name), {
      type: 'image/jpeg',
      lastModified: file.lastModified,
    })
  } catch {
    return file
  }
}
